import Api from '../Api';

export const getCustomers = () => async dispatch => {
  const { data } = await Api.get('/customers');
  dispatch({
    type: 'FETCH_CUSTOMERS',
    payload: data,
  });
};

export const clearCustomers = () => {
  return {
    type: 'CLEAR_CUSTOMERS',
  };
};

export const getCustomer = id => async dispatch => {
  const { data } = await Api.get(`/customers/${id}`);
  dispatch({
    type: 'FETCH_CUSTOMER',
    payload: data,
  });
};

export const clearCustomer = () => {
  return {
    type: 'CLEAR_CUSTOMER',
  };
};

export const getCustomerIds = () => async dispatch => {
  const { data } = await Api.get('/customers/ids');
  dispatch({
    type: 'FETCH_CUSTOMER_IDS',
    payload: data,
  });
};

export const clearCustomerIds = () => {
  return {
    type: 'CLEAR_CUSTOMER_IDS',
  };
};
